<template>
  <div class="row">
    <div class="col-md-12 pad-to-5">
      <fiscal-printer-form :route="route" @on-submit="onUserSubmit"></fiscal-printer-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import FiscalPrinterForm from './FiscalPrinterForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      FiscalPrinterForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        orderPosModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onUserSubmit (model, isValid) {
        this.orderPosModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/fiscalPrinter/FiscalPrinterEdit.vue